import { CoverageStatus } from 'modules/inbound/shared/domain/CoverageStatusTypes';
import { IPaginationDTO } from 'modules/inbound/shared/domain/IPagination';
import {
  JITPlanningDTO,
  LoadTransportJitDTO
} from 'modules/inbound/shared/infraestructure/dto/PlanningTransportsDTO';

interface Supplier {
  id: number;
  name: string;
  last_updated: string;
  stock: number;
}
export interface JitComment {
  code: string;
  text: string;
}
export interface PartCoverageDTO {
  code: string;
  provider_code: string | null;
  pr: string;
  grouped_models: string[];
  date: string;
  con_type: string;
  provider_coverage: number | null;
  sequencer_coverage_status: CoverageStatus;
  lines: string[];
  models: string | null;
  families: string[];
  sequencer_coverage: string | number | null;
  provider_type: string;
  margin: string;
  planning: JITPlanningDTO<LoadTransportJitDTO>[];
  critical_threshold_days: number;
  security_threshold_days: number;
  logistic_operator: Supplier;
  provider_tier_1: Supplier;
  description: string;
  inbounder: string;
  comment: JitComment;
  stock_quantity: string; //Column Stock (cantidad)
  has_remark: boolean;

  // ✅ Nuevos campos
  m100_launches_count: number; //columnLanzamientos M100
  stock_sequence: number; //Column Stock (secuencia)
  coverage_sequence: number | null; //Column Cobertura (secuencia)
  coverage_stopped_at: string | null; //Column Cobertura (fecha y hora)
  line_stopped_at: string | null; //Column Paro linea ( Fecha y Hora)
  production_order_id: number; // Not show
  fis_jit_updated_at: string | null; // next sprint
  fismoon_updated_at: string | null; // next sprint
  is_on_locks: boolean | null; // tarea KTCV-394
}

class PartCoverageDataDTO {
  planning_dates: string[];
  stock: PartCoverageDTO[];
  pagination: IPaginationDTO;
  update_planning: string | null;
  fis_jit_updated_at: string | null;
  fismoon_updated_at: string | null;
  slate_updated_at: string | null;

  constructor({
    planning_dates,
    stock,
    pagination,
    update_planning,
    fis_jit_updated_at,
    fismoon_updated_at,
    slate_updated_at
  }) {
    this.planning_dates = planning_dates;
    this.stock = stock;
    this.pagination = pagination;
    this.update_planning = update_planning;
    this.fis_jit_updated_at = fis_jit_updated_at;
    this.fismoon_updated_at = fismoon_updated_at;
    this.slate_updated_at = slate_updated_at;
  }
}

export default PartCoverageDataDTO;
